import React, { useCallback, useEffect } from 'react';
import { PropagateLoader } from 'react-spinners';
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';
import { useHistory } from 'react-router-dom';
import jwt from "jwt-decode";

export default function Subscribe(props) {
  localStorage.setItem('parcelNumber', props.match.params.parcelId);
  let history = useHistory();
  const parcelNumber = localStorage.getItem('parcelNumber')

  const createNewSubscription = useCallback(async () => {
    if (localStorage.getItem('token')) {
      const token = jwt(localStorage.getItem('token'));
      const accountId = token.id;
      const newSubscription = {
        parcelNumber: `${parcelNumber}`,
        isActive: true,
        accountId: `${accountId}`,
        alertTypeId: process.env.REACT_APP_ALERT_TYPE_ALL_ALERTS,
      };
      await eAlertsCoreAPIEndpoint(ENDPOINTS.SUBSCRIPTION)
        .create(newSubscription)
        .then((Response) => {
          if (Response.status === 200) {
            localStorage.removeItem('parcelNumber');
            history.push(`/dashboard/${accountId}`);
          } else {
            history.push(`/login?parcelnumber=${parcelNumber}`);
          }
        })
        .catch(() => {
          history.push(`/login?parcelnumber=${parcelNumber}`);
        });
    } else {
      history.push(`/login?parcelnumber=${parcelNumber}`);
    }

  }, [history, parcelNumber]);

  useEffect(() => {
    createNewSubscription();
  }, [createNewSubscription]);

  return (
    <>
      <Helmet>
        <title>Subscribe{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Row />
      <Row>
        <Col md="2" />
        <Col md="8" align="center">
          <br />
          <h2>Processing Your Subscription Request</h2>
        </Col>
        <Col md="2" />
      </Row>
      <Row>
        <Col md="2" />
        <Col md="8" align="center">
          <br />
          <PropagateLoader color="navy" loading="true" size="15" />
        </Col>
        <Col md="2" />
      </Row>
    </>
  );
}
